module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE PASSARO AIRWAYS")]), _vm._v(" skyliner went climbing up through the morning, Gomez said, “Well, I think it’s important.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not to me.” Jake was occupying the window seat.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His partner leaned slightly out into the aisle, eyes narrowing. “You’re not using the old "), _c('i', [_vm._v("cabeza,")]), _vm._v("” he said. “Whether the lovely lady attendant assigned to our section of this airship is an android or a true human—that’s "), _c('i', [_vm._v("muy importante.”")])]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“To you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay, say that the lovely ravenhaired lass yonder is indeed an android,” continued Gomez, watching her. “Then, which is not beyond the realm of possibility, especially considering the way she’s been eyeing me and simpering from the moment I stepped aboard, suppose that she and I arrange a rendezvous in Rio de Janeiro—after, of course, I’ve diligently helped you clean up the Sparey business. And suppose further that my current wife finds out about it and asks for a divorce. I’d hate, "), _c('i', [_vm._v("amigo,")]), _vm._v(" to have my marriage go flooey just because I shacked up with a machine.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“If that flight attendant were an android, Sid, she’d have to wear a tag identifying her as such. It’s the law.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“It could’ve fallen off.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Unlikely.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Or suppose the lass is a kamikaze, one of those assassinating andies so favored by the Tek gangs? If I were to give her nothing more than a cordial, avuncular pat on the backside—"), _c('i', [_vm._v("kapow!")]), _vm._v(" We explode and probably blow an unsightly hole in the side of this crate.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You ought to bring stuff to read on these trips,” suggested Jake, slouching further in his seat. “That would distract you, keep you from fantasizing.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You have to admit she has flawless skin.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Didn’t notice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“And perfect hair.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You can buy perfect hair at any mall.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“To me she seems much too attractive to be a mere human.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Next time she passes, ask her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Questions like that are difficult to put.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, at least spare me further speculations.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gomez sighed. “It’s tough having an obtuse partner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Meaning?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That the purpose of this sparkling dialogue, "), _c('i', [_vm._v("amigo,”")]), _vm._v(" admitted his partner, “has been to lift you out of the glum mood I find you in.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m not glum.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“No? You’d have to brighten up considerably before you could even get hired as a professional mourner.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake straightened up. “Shows, huh?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You having trouble with Beth?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Everything was fine in Berkeley.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Then you must be worrying that some of our Tek buddies will try to hurt her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake said, “You’ve been married several times.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("“Verdad,")]), _vm._v(" although beside the point.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I was married once.” Jake looked out at the bright morning sky. “The—well, you know all about Kate. Point is, I think I’m ready to try again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("“Bueno.")]), _vm._v(" You can’t do better than Beth.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sure, but I think she can do better than me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Not unless I was available.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake said, “I’m going to be fifty.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That happens to us all—unless we shake hands with a kamikaze or otherwise cash in our chips prematurely.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Beth isn’t even thirty.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That’s not an immense gap. Besides which, she obviously loves you.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There’s Dan to take into consideration, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Trust me, Jake, your son likes her and she likes him,” his partner assured him. “Soon as you two are back in Greater LA, go fetch a preacher. I’ll do the best man chores.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake grinned. “It’s a deal,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("The highly polished silver bellbot stepped over to the living room’s high, wide viewindow. The window was blanked. “And what view would you like, "), _c('i', [_vm._v("senhor?”")]), _vm._v(" he asked Gomez, silvery fingers hovering over the control panel.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“How about just what’s out there?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Ah, but the Hotel Maravilha offers no less than twenty-five exceptional views, brought to you by our exclusive skycam system,” explained the robot. “There is, for example, an absolutely stunning view of Sugar Loaf. Or you and your associate might prefer gazing on the famous immense statue of Christ that adorns—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“We’ll take care of it,” Jake told him. “You can go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“There is also, for the politically minded, a twenty-four-hour view of our perennial president, General Silveira, delivering choice—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Depart,” advised Gomez, nodding in the direction of the door.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’ll leave you with this one.” The bellbot touched a button. “An awesome vista of Ipanema Beach complete with a bevy of—”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So long,” said Gomez.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_c('i', [_vm._v("“Adeus.")]), _vm._v(" Enjoy the view—and your stay at the Maravilha.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gomez switched the window to "), _c('i', [_vm._v("Actual View.")]), _vm._v(" “Our actual view seems to be a stunning vista of the wall across the way.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, enjoy it,” said Jake. “I’m heading for the São Jose Private Hospital.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Gomez turned his back to the view. “I’ve worked on cases in Rio before,” he said. “While you’re calling on the ailing Jean Marie, I’ll contact some of my erstwhile informants and pay a few calls. Meet you back here at nightfall at the latest.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Jake headed for the door. “Be discreet.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m incapable of anything else,” his partner assured him.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3ded68","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9-chap6.vue
// module id = 87
// module chunks = 0